import UnderConstruction from "../../components/pages/under-construction";

function Blog() {
    let Component; // create custom component

  
    // render page based on component

    return (
        <>
            <UnderConstruction pageTitle="Blog"/>
        </>
    );
  }
  
  export default Blog;